/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import Degrees from 'bundles/epic/data/defaults/Degrees.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  enableDegreeHomeSalesforceSSO: boolean;
  enableZoomAccountLinking: boolean;
  showSelfEnrollIntoPrivateSessionsFlag: boolean;
  enablePendo: boolean;
  enableLmsInterop: boolean;
  gradebookManagerFilterDrafts: boolean;
  enableImpersonationEditMode: boolean;
  enablePersonaIDV: boolean;
  enableTeachPartnerFullStory: boolean;
  enableAdminFullStory: boolean;
  enableCourseraForOrganizationsV2Dasboards: boolean;
  enableCourseInsightsDashboard: boolean;
  showDegreeHomeV2: any;
  enableTeachProgramFullstory: boolean;
  showStudentHomeV2Beta1: boolean;
  enableWiseFlowAuthoring: boolean;
  enableWiseFlowTokenLogin: boolean;
  enableRecentlyViewed: boolean;
  enableDismissOverdueItems: boolean;
  showImprovedCertEnrollments: boolean;
  showDegreeHomeForDegreeSlugs: any;
  boulderMSCSLearnerIsPartOfDPMExperiment: boolean;
  showDPMPreProdDegrees: boolean;
  showDPMEventUX: boolean;
  showPBACurriculum: boolean;
  showDegreePlanningTool: boolean;
  showCMPhase1: boolean;
};

const NAMESPACE = 'Degrees';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([Degrees as $TSFixMe]);

const DegreesEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default DegreesEpicClient;
